<!--
  - Copyright (c) 2020. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <div class="mobile-top-header">
    <div class="icon" @click="openLeftMenu">
      <HamburgerIcon v-show="!leftMenuVisible"></HamburgerIcon>
    </div>
    <div class="mobile-top-header-title">
      <div>
        {{ $t("BGUK") }}
      </div>
    </div>
    <div class="language-indicator">
      <lang-switcher />
    </div>
    <div class="icon" @click="openRightMenu">
      <MoreIcon v-show="!rightMenuVisible"></MoreIcon>
    </div>
    <transition name="slidefromright">
      <div class="mobile-menu-overlay" v-if="rightMenuVisible">
        <div class="mobile-menu-overlay-header">
          <div class="flex-spacer"></div>
          <div class="icon" @click="hideRightMenu">
            <CloseIcon></CloseIcon>
          </div>
        </div>
        <div class="mobile-menu-overlay-items">
          <router-link
            :key="`menu_item_${idx}`"
            v-for="(item, idx) in topRightMenuItems"
            :to="item.to"
            v-slot="{ navigate }"
          >
            <div
              class="mobile-menu-overlay-item"
              @click="e => onMenuItemClicked(e, navigate)"
            >
              <div class="button is-full-width is-large is-light">
                {{ $t(item.label) }}
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </transition>
    <transition name="slidefromleft">
      <div class="mobile-menu-overlay" v-if="leftMenuVisible">
        <div class="mobile-menu-overlay-header">
          <div class="icon" @click="hideLeftMenu">
            <CloseIcon></CloseIcon>
          </div>
        </div>
        <div class="mobile-menu-overlay-items">
          <router-link
            v-slot="{ navigate, isExactActive }"
            :to="{ name: 'home' }"
          >
            <div
              class="mobile-menu-overlay-item"
              :title="$t('Return to home')"
              @click="e => onMenuItemClicked(e, navigate)"
            >
              <div
                class="button is-full-width is-large"
                :class="isExactActive ? 'is-light' : 'is-white'"
              >
                {{ $t("home") }}
              </div>
            </div>
          </router-link>
          <router-link
            :key="`menu_item_${idx}`"
            v-for="(item, idx) in topLeftMenuItems"
            :to="item.to"
            v-slot="{ navigate, isExactActive }"
          >
            <div
              class="mobile-menu-overlay-item"
              @click="e => onMenuItemClicked(e, navigate)"
            >
              <div
                class="button is-full-width is-large"
                :class="isExactActive ? 'is-light' : 'is-white'"
              >
                {{ $t(item.label) }}
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import HamburgerIcon from "@images/menu.svg";
import LangSwitcher from "./lang-switcher-simple";
import CloseIcon from "@images/clear-24px.svg";
import MoreIcon from "@images/dots-vertical.svg";
import { TopLeftMenuItems } from "@/services/menu";

export default {
  components: {
    HamburgerIcon,
    MoreIcon,
    LangSwitcher,
    CloseIcon
  },
  computed: {
    topLeftMenuItems() {
      return TopLeftMenuItems;
    },
    topRightMenuItems() {
      return [
        {
          label: "Account",
          to: {}
        },
        {
          label: "Search",
          to: {}
        }
      ];
    }
  },
  data() {
    return {
      leftMenuVisible: false,
      rightMenuVisible: false
    };
  },
  methods: {
    openLeftMenu() {
      this.leftMenuVisible = true;
    },
    hideLeftMenu() {
      this.leftMenuVisible = false;
    },
    openRightMenu() {
      this.rightMenuVisible = true;
    },
    hideRightMenu() {
      this.rightMenuVisible = false;
    },
    onMenuItemClicked(e, navigateFn) {
      this.hideLeftMenu();
      navigateFn(e);
    }
  }
};
</script>
<style lang="scss" scoped></style>
<style lang="scss">
@import "./../page-header-unscoped";

//slide from left animation
.slidefromleft-enter-active,
.slidefromleft-leave-active {
  transition: 0.2s;
}
.slidefromleft-enter, .slidefromleft-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translate3d(-100vw, 0, 0);
}

.slidefromright-enter-active,
.slidefromright-leave-active {
  transition: 0.2s;
}
.slidefromright-enter, .slidefromright-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translate3d(+100vw, 0, 0);
}

.mobile-top-header {
  display: flex;
  justify-content: space-between;

  .mobile-top-header-title {
    flex-grow: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 1.5rem;
    line-height: 1.5rem;
  }

  .language-indicator {
    width: $pageHeaderHeightMobile;
    height: $pageHeaderHeightMobile;
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
  }

  .mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.9);
    overflow: auto;

    .mobile-menu-overlay-header {
      display: flex;
      width: 100%;
      height: $pageHeaderHeightMobile;
    }

    .mobile-menu-overlay-items {
      display: flex;
      flex-direction: column;

      .mobile-menu-overlay-item {
        text-transform: capitalize;
        font-size: 1.5rem;
      }
    }
  }

  .icon {
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    width: $pageHeaderHeightMobile;
    height: $pageHeaderHeightMobile;

    svg {
      width: 48px;
      height: 48px;
      fill: $text;
    }
  }
}
</style>
